import { createI18n } from "vue-i18n";
import zhLocale from "./zh-CN";
import twLocale from "./zh-TW";
import { persistLocale, resolveInitialLocale } from "@/utils/locale";
const messages = {
  "zh-TW": {
    msg: {
      ...twLocale,
    },
  },
  "zh-CN": {
    msg: {
      ...zhLocale,
    },
  },
};

const initialLocale = resolveInitialLocale();
persistLocale(initialLocale);
const i18n = createI18n({
  // 使用 composition Api
  legacy: true,
  // 全局使用 t函数
  // globalInjection: true,
  locale: initialLocale,
  messages,
});

export default i18n;
export { initialLocale };
